import script from "./DetectionView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetectionView.vue?vue&type=script&setup=true&lang=js"

import "./DetectionView.vue?vue&type=style&index=0&id=6028b646&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6028b646"]])

export default __exports__